import React from 'react';
import { connect } from 'react-redux';

import { Col, Row, View } from '@amzn/stencil-react-components/layout';
import { Avatar } from '@amzn/stencil-react-components/avatar';
import {
  PageHeader,
  PageHeaderButton,
  PageHeaderDropdown,
  PageHeaderDropdownButton,
} from '@amzn/stencil-react-components/page';
import { Text } from '@amzn/stencil-react-components/text';
import { Spacer } from '@amzn/stencil-react-components/layout';
import { Flyout } from '@amzn/stencil-react-components/flyout';
import { FlyoutContent } from '@amzn/stencil-react-components/flyout';

import { Select } from '@amzn/stencil-react-components/select';

import { setLoggedOut } from '../actions/userInfoActions';
import { Button } from '@amzn/stencil-react-components/button';
import { withRouter } from 'react-router-dom';
import { InputWrapper } from '@amzn/stencil-react-components/input';
import { ApplicationContext } from '../components/context/ApplicationContext';
import { HOME_PAGE } from '../constants/routesConstant';
import WelcomeSlides from '../components/WelcomeSlides/WelcomeSlides';
import { FormattedMessage } from 'react-intl';

import { IconPersonSmall } from '@amzn/stencil-react-icons';
import { IconInformationSmall } from '@amzn/stencil-react-icons';

class HeaderContainer extends React.Component {
  static contextType = ApplicationContext;
  state = {
    preferenceFlyoutOpen: false,
    language: '',
    openAboutNudge: false,
  };
  constructor(props) {
    super(props);
    this.preferenceClickHandler = this.preferenceClickHandler.bind(this);
    this.preferenceLanguageHandler = this.preferenceLanguageHandler.bind(this);
    this.openAboutNudgeSlide = this.openAboutNudgeSlide.bind(this);
  }

  preferenceClickHandler(isOpen) {
    this.setState({ ...this.state, preferenceFlyoutOpen: isOpen });
  }

  preferenceLanguageHandler(lang) {
    this.setState({ ...this.state, language: lang });
    this.context.dispatch({ type: 'SET_LOCALE', payload: lang.value });
  }

  openAboutNudgeSlide() {
    this.setState({ ...this.state, openAboutNudge: true });
  }

  render() {
    const applicationContext = this.context;
    const preferenceLangOptions = [
      {
        label: 'English',
        value: 'en',
      },
      {
        label: 'French',
        value: 'fr',
      },
    ];
    const defaultLangValue = preferenceLangOptions.filter(
      lang => lang.value === applicationContext?.contextState?.locale,
    )[0];
    const optionToString = option => option.value;
    const renderOption = option => (
      <Row gridGap="S200" alignItems="center" key={option.label}>
        {option.label}
      </Row>
    );
    const currentProps = this.props;
    const lang = this.state.language;
    return (
      <View>
        <PageHeader colorScheme={'inverted'} hasShadow={false} isFullWidth={true} isFixed={true}>
          <PageHeaderButton
            title="Placeholder of logo"
            data-testid="logo-btn"
            onClick={() => {
              currentProps.history.push(HOME_PAGE);
            }}
            hasHover={false}
            paddingHorizontal={0}
          >
            <View display="flex" justifyContent="center" height={40} width={'auto'} padding={'5px'}>
              <Row gridGap={'S100'}>
                <Text fontWeight={'bold'}>Nudge</Text>
                <Text color={'primary20'} font={'monospace'}>
                  engine
                </Text>
              </Row>
            </View>
          </PageHeaderButton>
          <Spacer flex={1} />
          <Row gridGap="S200">
            <PageHeaderButton
              data-testid="about-nudge-btn"
              onClick={() => this.openAboutNudgeSlide()}
              icon={<IconInformationSmall aria-hidden={true} />}
            >
              <FormattedMessage id="app.header.aboutNudge" defaultMessage="About Nudge" />
            </PageHeaderButton>
          </Row>
          {this.props.userInfo.user === '' && (
            <PageHeaderButton onClick={() => {}} icon={<IconPersonSmall aria-hidden={true} />}>
              Login
            </PageHeaderButton>
          )}
          {this.props.userInfo.user !== '' && (
            <PageHeaderDropdown
              data-testid="user-icon"
              items={[
                <PageHeaderDropdownButton onClick={() => this.preferenceClickHandler(true)}>
                  Preferences
                </PageHeaderDropdownButton>,
              ]}
            >
              <Avatar
                fullName=""
                username={this.props.userInfo.user}
                colorScheme="inverted"
                size="m"
                usernameClickable={false}
                borderRadius={0}
              />
            </PageHeaderDropdown>
          )}
          <Flyout
            isOpen={this.state.preferenceFlyoutOpen}
            close={() => this.preferenceClickHandler(false)}
          >
            <FlyoutContent
              titleText="Preferences"
              onCloseButtonClick={() => this.preferenceClickHandler(false)}
              buttons={[
                <Button primary onClick={() => this.preferenceClickHandler(false)}>
                  Close
                </Button>,
              ]}
            >
              <Col gridGap="S500">
                <Text />
                <InputWrapper id="site-wide-language" labelText="Language">
                  {inputProps => (
                    <Select
                      renderOption={renderOption}
                      options={preferenceLangOptions}
                      value={lang || defaultLangValue}
                      onChange={this.preferenceLanguageHandler}
                      optionToString={optionToString}
                      placeholder="Choose a language"
                    />
                  )}
                </InputWrapper>
              </Col>
            </FlyoutContent>
          </Flyout>
        </PageHeader>
        <WelcomeSlides
          isOpen={this.state.openAboutNudge}
          close={() => this.setState({ ...this.state, openAboutNudge: false })}
        />
      </View>
    );
  }
}

const mapStateToProps = state => ({
  nudge: { ...state.nudge },
  userInfo: { ...state.userInfo },
});

const mapDispatchToProps = {
  setLoggedOut,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(HeaderContainer));
